
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M21.23 14.676H19.8v-1.432c0-.116-.117-.232-.194-.232h-1.238a.25.25 0 00-.232.232v1.432h-1.432c-.116 0-.194.116-.194.194v1.238c0 .116.078.232.194.232h1.432v1.431c0 .117.116.194.232.194h1.238c.077 0 .194-.077.194-.194V16.34h1.431a.25.25 0 00.232-.232v-1.239c0-.077-.116-.193-.232-.193z","fill":"#FFC511"}}),_c('path',{attrs:{"d":"M14.74 15.489a4.256 4.256 0 014.246-4.247c2.32 0 4.246 1.927 4.246 4.247a4.256 4.256 0 01-4.246 4.246 4.232 4.232 0 01-4.247-4.246zM3.664 10.47a2.464 2.464 0 002.477-2.476 2.484 2.484 0 00-2.477-2.476 2.464 2.464 0 00-2.476 2.476 2.445 2.445 0 002.476 2.477z","stroke":"#000"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.617 11.457a3.822 3.822 0 100-7.644 3.822 3.822 0 000 7.644z","stroke":"#000"}}),_c('path',{attrs:{"d":"M5.882 12.338a.499.499 0 00-.208-.132 4.369 4.369 0 00-.952-.204L4.7 12H3.239C1.424 12 0 13.546 0 15.383a.5.5 0 001 0C1 14.048 2.026 13 3.239 13h1.42c.083.008.18.023.283.044.287-.266.602-.503.94-.706zM13.192 12.982l-.122.036a4.654 4.654 0 01-1.454.218 4.65 4.65 0 01-1.454-.218l-.137-.041c-.335-.103-.709-.218-1.179-.218-2.553 0-4.654 2.005-4.654 4.513v1.655c0 1.084.906 1.934 1.984 1.934h8.831a6.248 6.248 0 01-1.058-1H6.176c-.56 0-.984-.434-.984-.934v-1.655c0-1.923 1.62-3.513 3.654-3.513.312 0 .54.07.882.173l.148.044c.427.128.947.26 1.74.26.45 0 .811-.042 1.119-.103.114-.4.268-.786.457-1.151z","fill":"#000"}})])])
          )
        }
      }
    